<template>
  <section class="period2014wrap six-trials" v-parallax v-slide-up-in>
    <v-page :background="theme.colors.cyan">
      <v-chapter-years-title :pageData="info" v-slide-up-in-stage="1" />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-picture-carousel
        :pictures="persecutionPicture[0]"
        :showInfo="true"
        v-slide-up-in-stage="2"
        class-name="persecution-carousel"
      />
    </v-page>

    <v-page
      background="images/spread-of-kingdom-gospel/2006-2013/picturesCarouselBg.jpg"
    >
      <persecution-total-section :data="totalOfCapture" />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-picture-carousel
        :pictures="singlePicture"
        :showInfo="false"
        class-name="single-carousel"
      />
    </v-page>

    <v-page :background="theme.colors.earth">
      <video-carousels :videoData="videoData" />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :html="pageDataItem.GodsWord.data.content"
      />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-full-screen-songs-player
        :data="pageDataItem.audios.data"
        bg="images/common/hymnsPosters/spread-of-kingdom-gospel.jpg"
      />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-chatper-entry bg-color="earth" />
    </v-page>
  </section>
</template>

<script>
import { mapState } from "vuex";
import PersecutionTotalSection from "@/components/persecution-total-section/index.vue";
import videoCarousels from "./components/videoCarousels/index";

export default {
  computed: {
    ...mapState("global", ["schema"]),
  },
  data() {
    return {
      pageDataItem: {},
      totalOfCapture: {},
      info: "",
      videoData: [],
      persecutionPicture: [],
    };
  },
  components: {
    PersecutionTotalSection,
    videoCarousels,
  },
  methods: {},
  async created() {
    this.pageDataItem = this.schema["2014-to-the-present"].item;
    this.info = this.pageDataItem.info;
    this.totalOfCapture = this.pageDataItem.totalOfCapture.data;
    this.videoData = this.pageDataItem.videosLists.data;
    this.persecutionPicture = this.pageDataItem.picture.data;
    this.singlePicture = this.pageDataItem.singlePicture;
  },
  mounted() {},
};
</script>

<style lang="scss">
.period2014wrap {
  .v-chapter-years-title {
    padding-bottom: 0;
  }
}

.video-type-title {
  font-size: 20px;
  margin: 20px;
}
</style>
